import React, { useEffect, useState } from 'react';
import Loader from 'shared/common/loader';
import StaticModal from 'shared/common/modal/staticModal';
import failedImg from '../../assets/images/exclamation.svg';
 
interface PropsType {
  redirectFunc?: any;
  showModal?: any;
  closeModal?: any;
  proceed?: any;
  cancel?: any;
  text?: any;
  keytext?: any;
  okButton?: any;
  cancelButton?: any;
  title?: any;
  corpGiftMessage?: any;
}
const PaymentFailedModal: React.FC<PropsType> = ({
  redirectFunc,
  showModal,
  cancel,
  title,
}) => {
  const [countDown, setCountDown] = useState(8);
  const [loading, setLoading] = useState(false);
 
  useEffect(() => {
    if (showModal && countDown > 0) {
      const timer = setTimeout(() => {
        setCountDown(countDown - 1);
      }, 1000);
 
      return () => clearTimeout(timer);
    }
 
    if (countDown == 0) {
      setLoading(true);
      setTimeout(() => {
        redirectFunc();
      }, 1000);
    }
  }, [countDown, showModal, redirectFunc]);
 
  return (
    <>
      {loading && <Loader />}
      <StaticModal
        show={showModal}
        handleClose={() => cancel()}
        title={'Payment Processing Update'}
        onClose={() => {
          cancel();
        }}
        // size='lg'
 
        center
      >
        <div>
          <div className=''>
            <div className='d-flex justify-content-center '>
              <img src={failedImg} height={80} width={80} />
            </div>
            <div
              className='row h-100 p-3'
              style={{ color: 'grey', fontSize: '14px' }}
            >
              Your Emandate creation is under process. Kindly hold and do not
              refresh this page. Thank you for your patience.
            </div>
            <div className='text-center fw-bold'>
              Redirecting in {countDown} seconds...
            </div>
          </div>
        </div>
      </StaticModal>
    </>
  );
};
 
export default PaymentFailedModal;